module.exports = __webpack_public_path__ + "img/dorde_obradovic.1773751c.png";